import { User } from "@ticketingplatform/api/dist/users/__generated__/User";
import { VenueUser } from "@ticketingplatform/api/dist/venueUser/fragments/__generated__/VenueUser";
import { ColumnsType } from "antd/es/table";
import { useIntl } from "react-intl";
import { useMemo } from "react";

import { UseUserColumnsProps } from "./types";

export const useUserColumns = <TRecord extends User | VenueUser>({
  sortOrder,
  additionalColumns = [],
}: UseUserColumnsProps<TRecord>): ColumnsType<TRecord> => {
  const intl = useIntl();

  return useMemo<ColumnsType<TRecord>>(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: "First Name",
        }),
        dataIndex: "firstName",
        key: "firstName",
        ...(sortOrder
          ? {
              sortOrder: sortOrder.firstName,
              sorter: {
                multiple: 1,
              },
            }
          : undefined),
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Last Name",
        }),
        dataIndex: "lastName",
        key: "lastName",
        ...(sortOrder
          ? {
              sortOrder: sortOrder.lastName,
              sorter: {
                multiple: 2,
              },
            }
          : undefined),
      },
      {
        title: intl.formatMessage({
          defaultMessage: "Permission level",
        }),
        key: "role",
        dataIndex: "role",
        ...(sortOrder
          ? {
              sortOrder: sortOrder.role,
              sorter: {
                multiple: 3,
              },
            }
          : undefined),
      },
      ...additionalColumns,
    ],
    [intl, sortOrder, additionalColumns]
  );
};
